import { render } from "./App.vue?vue&type=template&id=dbd88f04"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=dbd88f04&lang=css"

import exportComponent from "C:\\Users\\peter\\Documents\\_projekte\\georg_fischer\\vue3_flow_calculator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__